import { siteInfo } from '@/mocks/home';

const footerLinks = [
  {
    title: '阅读模式',
    items: ['下拉式阅读', '翻页模式', '弹窗模式', '阅读指南'],
  },
  {
    title: '漫画类型',
    items: ['韩漫专区', '日漫经典', '国漫之光', '完结全集'],
  },
  {
    title: '帮助中心',
    items: ['常见问题', '联系我们', '投稿合作', '版权声明'],
  },
  {
    title: '合作伙伴',
    items: [],
  },
];

export default function Footer() {
  return (
    <footer id="footer" className="bg-background-950 text-background-200">
      <div className="section-container py-12 md:py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-10">
          {footerLinks.map((col) => (
            <div key={col.title}>
              <h4 className="font-heading text-sm font-bold text-background-50 mb-3">
                {col.title}
              </h4>
              {col.items.length > 0 ? (
                <ul className="space-y-2">
                  {col.items.map((link) => (
                    <li key={link}>
                      <a
                        href="#"
                        onClick={(e) => e.preventDefault()}
                        className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer whitespace-nowrap"
                      >
                        {link}
                      </a>
                    </li>
                  ))}
                </ul>
              ) : (
                <p className="text-sm text-background-500">暂无展示</p>
              )}
            </div>
          ))}
        </div>

        <div className="border-t border-background-800 pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <div className="text-center md:text-left">
            <p className="text-sm text-background-400">
              <strong className="text-background-100 font-heading">{siteInfo.fullName}</strong>
              <span className="mx-2">—</span>
              下拉式·翻页·弹窗，流畅免费看全集热门漫画
            </p>
            <p className="text-xs text-background-500 mt-1">
              韩漫日漫国漫资源在线看 | 收录15,000+部漫画作品 | 每日更新200+章节
            </p>
          </div>
          <p className="text-xs text-background-500 whitespace-nowrap">
            © 2018-2026 香蕉文化漫画网
          </p>
        </div>
      </div>
    </footer>
  );
}